export const trackingEvents = {
  VIEWED: 'admin_duplicate_accounts_page_alert.main.viewed',
  MANAGE_ACCOUNTS: 'admin_duplicate_accounts_page_alert.manage_accounts.clicked',
  DISMISS: 'admin_duplicate_accounts_page_alert.dismiss.clicked',
} as const
